import React, { useEffect, useState } from "react";
import "./offering.css";
import styles from "../Offerings/Offering.module.css";
import Banner from "../../assets/images/our-product-banner.jpg";
import Button from "../../commomComponents/button";
import { Grid } from "@material-ui/core";
import ReactHtmlParser from "react-html-parser";
import getOfferingDetails from "../../services/request/offering";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import CommonButton from "../LearnMore/commonComponents/button";
import youtubeImage from "../../assets/images/presentation-border.svg";
import downloadImage from "../../assets/images/Download-white.svg";
import factsheetIconWhite from "../../assets/images/factsheetIconWhite.svg";
import sortingObj from "../../utils/sortingObject";
import { downloadPdf } from "../../utils/downloadPdf";
import Mail from "../../commomComponents/mail";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";

export default function Offering() {
  const [wholeSet, setWholeSet] = useState([]);
  const [banner, setBanner] = useState({
    title: "",
    image: "",
  });
  const [loader, setLoader] = useState(false);
  const [isOnhoverPresentationBtn, setIsOnhoverPresentationBtn] =
    useState(false);
  const [isOnhoverFactsheetBtn, setIsOnhoverFactsheetBtn] = useState(false);
  const [isClickedPresentationBtn, setIsClickedPresentationBtn] =
    useState(false);
  const [isClickedFactsheetBtn, setIsClickedFactsheetBtn] = useState(false);
  //
  const onClick = async (e, name, urlPdf) => {
    e.preventDefault();

    const url = IMAGE_URL + urlPdf + SITE_ID;

    switch (name) {
      case "presentationBtn":
        return downloadPdf(url, urlPdf?.split("/").pop().split(".")[0]);
      case "factsheetBtn":
        return downloadPdf(url, urlPdf?.split("/").pop().split(".")[0]);
      default:
        return;
    }
  };

  const onMouseHoverPresentationsBtn = () => {
    setIsOnhoverPresentationBtn(true);
  };
  const onMouseLeavePresentationsBtn = () => {
    setIsOnhoverPresentationBtn(false);
  };

  const onMouseHoverFactsheetBtn = () => {
    setIsOnhoverFactsheetBtn(true);
  };
  const onMouseLeaveFactsheetBtn = () => {
    setIsOnhoverFactsheetBtn(false);
  };
  const history = useHistory();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Function to handle navigation and scroll to top
  const handleLinkClick = (path) => {
    history.push(path);
    scrollToTop();
  };

  const onClickLearnMore = (id, index) => {
    switch (id) {
      case 1:
        return "/portfolio-management-service/contrarian-investing";
      case 2:
        return "/portfolio-management-service/pipe-pms";
      case 3:
        return "/portfolio-management-service/growth-leaders-strategy";
      case 4:
        return "/portfolio-management-service/largecap-strategy";
      case 5:
        return "/portfolio-management-service/value-strategy";
      case 6:
        return "/portfolio-management-service/ace-strategy";
      default:
        return "/";
    }
  };
  //
  useEffect(() => {
    document.title =
      "Portfolio Management Services - Smart PMS Investments | ICICI Pru Alternates";
    setLoader(true);
    const offering = getOfferingDetails();
    offering.then((data) => {
      banner["title"] = data.data.banner[0].title;
      banner["image"] = data.data.banner[0].image;
      setBanner({ ...banner });
      setWholeSet(data.data.ourofferings);
      console.log(data.data.ourofferings);
      setLoader(false);
    });
  }, []);

  return (
    <>
      <SeoHelmet
        title="Portfolio Management Services - Smart PMS Investments | ICICI Pru Alternates"
        description="Portfolio Management Services are tailored investment solutions offered by professional portfolio fund managers to grow your wealth. Learn about 6 PMS strategies."
        url="https://www.iciciprualternates.com/portfolio-management-service"
      />
      <div className={styles.container}>
        {loader === true ? (
          <Loader />
        ) : (
          <>
            <Mail />
            <div className={styles.banner_section}>
              {/* {banner["image"] && (
              <BannerWithHeading
                bannerImage={IMAGE_URL + banner["image"] + SITE_ID}
                heading={banner["title"]}
              />
            )} */}
              <div className={styles.imageBanner}>
                {banner["image"] && (
                  <img
                    src={IMAGE_URL + banner["image"] + SITE_ID}
                    alt="Portfolio management services"
                  />
                )}
              </div>
              <div
                className={styles.main_button}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-evenly",
                  margin: "-6% 34% 10% 34%",
                  flexDirection: "row",
                }}
              ></div>
            </div>
            <div className={styles.Laptop}>
              {sortingObj(wholeSet, "id").map((data, i) => {
                if (i % 2 === 0) {
                  return (
                    <div
                      className={styles.spacing}
                      id={
                        data.title === "Alternative Investment Funds (AIF)"
                          ? "AIF"
                          : `PMS${i}`
                      }
                    >
                      <Grid container spacing={2} className={styles.grid_one}>
                        <Grid item xs>
                          {data.image && (
                            <img
                              src={IMAGE_URL + data.image + SITE_ID}
                              alt={data.title}
                              loading="lazy"
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          xs
                          style={{ marginTop: "-3%", paddingLeft: "3%" }}
                        >
                          <p className={styles.grid_one_title}>
                            {data.title}

                            {/* <span className={styles.tag}>{data.type}</span> */}
                          </p>
                          <p className={styles.grid_one_text}>
                            <div className={styles.listStyle}>
                              {ReactHtmlParser(data.text)}
                            </div>
                          </p>

                          <div className="mainDivButtons">
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: 0,
                                }}
                              >
                                <a
                                  href="#"
                                  urlPdf={
                                    data["presentationDoc"]?.item[0]?.value
                                  }
                                  id="presentationBtn"
                                  onClick={(e) => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                      event: "PMSpresentation_Download",
                                      inquiryType: "",
                                      buttonName: "Presentations",
                                      email: "", // Encrypted email of the User using SHA-256 encryption
                                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                      clientID: "",
                                      queryMessage: "",
                                      state: "",
                                      pageSection: "",
                                      Category: data.title,
                                      FAQ: "",
                                    });
                                    onClick(
                                      e,
                                      "presentationBtn",
                                      data["presentationDoc"]?.item[0]?.value
                                    );
                                  }}
                                  class="btn-flip-presentation"
                                  data-back="Download"
                                  data-front="Presentations"
                                  onContextMenu={(e) => e.preventDefault()}
                                ></a>
                              </button>
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: 0,
                                }}
                              >
                                <a
                                  href="#"
                                  urlPdf={data["factsheetDoc"]?.item[0]?.value}
                                  id="factsheetBtn"
                                  onClick={(e) => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                      event: "PMSfactsheet_download",
                                      inquiryType: "",
                                      buttonName: "Factsheet",
                                      email: "", // Encrypted email of the User using SHA-256 encryption
                                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                      clientID: "",
                                      queryMessage: "",
                                      state: "",
                                      pageSection: "",
                                      Category: data.title,
                                      FAQ: "",
                                    });
                                    onClick(
                                      e,
                                      "factsheetBtn",
                                      data["factsheetDoc"]?.item[0]?.value
                                    );
                                  }}
                                  class="btn-flip-factsheet"
                                  data-back="Download"
                                  data-front="Factsheet"
                                  onContextMenu={(e) => e.preventDefault()}
                                ></a>
                              </button>
                            </div>
                            <div className="buttonDiv">
                              <Link
                                to={onClickLearnMore(data.id)}
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "learnMore_click",
                                    inquiryType: "",
                                    buttonName: "Learn More",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  handleLinkClick();
                                }}
                                // onClick={handleLinkClick}
                                className="buttonLearnMore"
                              >
                                Learn More
                              </Link>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className={styles.spacing}
                      id={
                        data.title === "Alternative Investment Funds (AIF)"
                          ? "AIF"
                          : `PMS${i}`
                      }
                    >
                      <Grid container spacing={2} className={styles.grid_one}>
                        <Grid
                          item
                          xs
                          style={{ marginTop: "-3%", paddingLeft: "3%" }}
                        >
                          <p className={styles.grid_one_title}>
                            {data.title}
                            {/* {data["type"] !== null && (
                            <span className={styles.tag}>{data.type}</span>
                          )} */}
                          </p>
                          <p className={styles.grid_one_text}>
                            <div className={styles.listStyle}>
                              {ReactHtmlParser(data.text)}
                            </div>
                          </p>
                          <div className="mainDivButtons">
                            {data["presentationDoc"] !== null && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor: "transparent",
                                    border: 0,
                                  }}
                                >
                                  <a
                                    href="#"
                                    urlPdf={
                                      data["presentationDoc"]?.item[0]?.value
                                    }
                                    id="presentationBtn"
                                    onClick={(e) => {
                                      window.dataLayer = window.dataLayer || [];
                                      window.dataLayer.push({
                                        event: "PMSpresentation_Download",
                                        inquiryType: "",
                                        buttonName: "Presentations",
                                        email: "", // Encrypted email of the User using SHA-256 encryption
                                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                        clientID: "",
                                        queryMessage: "",
                                        state: "",
                                        pageSection: "",
                                        Category: data.title,
                                        FAQ: "",
                                      });
                                      onClick(
                                        e,
                                        "presentationBtn",
                                        data["presentationDoc"]?.item[0]?.value
                                      );
                                    }}
                                    class="btn-flip-presentation"
                                    data-back="Download"
                                    data-front="Presentations"
                                    onContextMenu={(e) => e.preventDefault()}
                                  ></a>
                                </button>
                                <button
                                  style={{
                                    backgroundColor: "transparent",
                                    border: 0,
                                  }}
                                >
                                  <a
                                    href="#"
                                    urlPdf={
                                      data["factsheetDoc"]?.item[0]?.value
                                    }
                                    id="factsheetBtn"
                                    onClick={(e) => {
                                      window.dataLayer = window.dataLayer || [];
                                      window.dataLayer.push({
                                        event: "PMSfactsheet_download",
                                        inquiryType: "",
                                        buttonName: "Factsheet",
                                        email: "", // Encrypted email of the User using SHA-256 encryption
                                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                        clientID: "",
                                        queryMessage: "",
                                        state: "",
                                        pageSection: "",
                                        Category: data.title,
                                        FAQ: "",
                                      });
                                      onClick(
                                        e,
                                        "factsheetBtn",
                                        data["factsheetDoc"]?.item[0]?.value
                                      );
                                    }}
                                    class="btn-flip-factsheet"
                                    data-back="Download"
                                    data-front="Factsheet"
                                    onContextMenu={(e) => e.preventDefault()}
                                  ></a>
                                </button>
                              </div>
                            )}
                            <div className="buttonDiv">
                              <Link
                                to={onClickLearnMore(data.id)}
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "learnMore_click",
                                    inquiryType: "",
                                    buttonName: "Learn More",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  handleLinkClick();
                                }}
                                className="buttonLearnMore"
                              >
                                Learn More
                              </Link>
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs>
                          {data.image && (
                            <img
                              src={IMAGE_URL + data.image + SITE_ID}
                              alt=""
                              loading="lazy"
                            />
                          )}
                        </Grid>
                      </Grid>
                    </div>
                  );
                }
              })}
            </div>
            <div className={styles.mobile}>
              {sortingObj(wholeSet, "id").map((data, i) => {
                return (
                  <div className={styles.spacing} key={i}>
                    <Grid container spacing={2} className={styles.grid_one}>
                      <Grid item xs>
                        {data.image && (
                          <img
                            src={IMAGE_URL + data.image + SITE_ID}
                            alt={data.title}
                            loading="lazy"
                          />
                        )}
                      </Grid>
                      <Grid item xs>
                        <p className={styles.grid_one_title}>
                          {data.title}
                          {/* {data["type"] !== null && (
                          <span className={styles.tag}>{data.type}</span>
                        )} */}
                        </p>
                        <p className={styles.grid_one_text}>
                          {ReactHtmlParser(data.text)}
                        </p>

                        <div className="mainDivButtons">
                          {data["presentationDoc"] !== null && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                // Add flex-wrap for smaller screens
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: 0,
                                }}
                              >
                                <a
                                  urlPdf={
                                    data["presentationDoc"]?.item[0]?.value
                                  }
                                  id="presentationBtn"
                                  onClick={(e) => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                      event: "PMSpresentation_Download",
                                      inquiryType: "",
                                      buttonName: "Presentations",
                                      email: "", // Encrypted email of the User using SHA-256 encryption
                                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                      clientID: "",
                                      queryMessage: "",
                                      state: "",
                                      pageSection: "",
                                      Category: data.title,
                                      FAQ: "",
                                    });
                                    onClick(
                                      e,
                                      "presentationBtn",
                                      data["presentationDoc"]?.item[0]?.value
                                    );
                                  }}
                                  className="btn-flip-presentation"
                                  data-back="Download"
                                  data-front="Presentations"
                                  onContextMenu={(e) => e.preventDefault()}
                                ></a>
                              </button>
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: 0,
                                }}
                              >
                                <a
                                  urlPdf={data["factsheetDoc"]?.item[0]?.value}
                                  id="factsheetBtn"
                                  onClick={(e) => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                      event: "PMSfactsheet_download",
                                      inquiryType: "",
                                      buttonName: "Factsheet",
                                      email: "", // Encrypted email of the User using SHA-256 encryption
                                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                      clientID: "",
                                      queryMessage: "",
                                      state: "",
                                      pageSection: "",
                                      Category: data.title,
                                      FAQ: "",
                                    });
                                    onClick(
                                      e,
                                      "factsheetBtn",
                                      data["factsheetDoc"]?.item[0]?.value
                                    );
                                  }}
                                  className="btn-flip-factsheet"
                                  data-back="Download"
                                  data-front="Factsheet"
                                  onContextMenu={(e) => e.preventDefault()}
                                ></a>
                              </button>
                            </div>
                          )}
                          <div className="buttonDiv">
                            <Link
                              to={onClickLearnMore(data.id)}
                              onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                  event: "learnMore_click",
                                  inquiryType: "",
                                  buttonName: "Learn More",
                                  email: "", // Encrypted email of the User using SHA-256 encryption
                                  contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                  clientID: "",
                                  queryMessage: "",
                                  state: "",
                                  pageSection: "",
                                  Category: data.title,
                                  FAQ: "",
                                });
                                handleLinkClick();
                              }}
                              className="buttonLearnMore"
                            >
                              Learn More
                            </Link>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
}
